import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useState, useEffect } from 'react';
import Loader from '../components/Loader';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faRestroom, faWarehouse, faTint, faPlugCircleCheck, faWifi } from '@fortawesome/free-solid-svg-icons';
import FichaTecnicaModal from '../components/FichaTecnicaModal';
import { useGlobalContext } from '../Config';

const ProductosDisponibles = () => {
    const { baseUrl } = useGlobalContext();
    const [loading, setLoading] = useState(false);
    const [empresas, setEmpresas] = useState([]);
    const [tipoProducto, setTipoProducto] = useState([]);
    const [empresa, setEmpresa] = useState(null);
    const [empresaId, setEmpresaId] = useState(null);
    const [tiposProducto, setTiposProducto] = useState([]);
    const [fechaDesde, setFechaDesde] = useState(null);
    const [fechaHasta, setFechaHasta] = useState(null);
    const [productosDisponibles, setProductosDisponibles] = useState([]);
    const [carro, setCarro] = useState([]);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [showFichaModal, setShowFichaModal] = useState(false);
    const [selectedProductoFicha, setSelectedProductoFicha] = useState(null);

    const openFichaModal = (producto) => {
        setSelectedProductoFicha(producto);
        setShowFichaModal(true);
    };

    const closeFichaModal = () => {
        setShowFichaModal(false);
        setSelectedProductoFicha(null);
    };

    const handleFechaDesdeChange = (e) => {
        const nuevaFecha = e.value;
        if (fechaHasta && nuevaFecha > fechaHasta) {
            setFechaHasta(null);
        }
        setFechaDesde(nuevaFecha);
    };

    const handleFechaHastaChange = (e) => {
        const nuevaFecha = e.value;
        if (fechaDesde && nuevaFecha < fechaDesde) {
            return;
        }
        setFechaHasta(nuevaFecha);
    };

    const fetchData = async (url) => {
        try {
            const response = await fetch(url, { method: "GET" });
            if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
            return response.json();
        } catch (error) {
            console.error("Error en fetchData:", error);
            throw error;
        }
    };

    const obtenerEmpresas = async () => {
        try {
            const data = await fetchData(`${baseUrl}/getAllEmpresas`);
            setEmpresas(data.empresas);
        } catch (error) {
            console.error("Error al obtener empresas:", error);
        }
    };

    const getTipoProductoByEmpresa = async (empresa) => {
        if (!empresa) return;
        try {
            const data = await fetchData(`${baseUrl}/getTiposProductoByEmpresa?empresa=${empresa}`);
            if (data?.tiposProductos) setTiposProducto(data.tiposProductos);
        } catch (error) {
            console.error("Error al obtener tipos de producto:", error);
        }
    };

    const buildProductosUrl = (empresasArray, desdeFiltro, hastaFiltro, tiposArray) => {
        if (empresa === "TODAS") {
            empresasArray = ["2", "3"];
        }
        return `${baseUrl}/getProductosByFiltro?empresas=${empresasArray.join(',')}&fechaInicio=${desdeFiltro}&fechaTermino=${hastaFiltro}&tipos=${tiposArray}`;
    };

    const handleProductosResponse = (data) => {
        if (Array.isArray(data?.productos)) {
            setProductosDisponibles(data.productos);
        } else {
            console.error("Error en formato de respuesta:", data);
        }
        setLoading(false);
    };

    const searchProductos = async () => {
        if (!empresa || !fechaDesde || !fechaHasta) {
            console.error("Faltan datos requeridos");
            return;
        }
        setLoading(true);
        try {
            const desdeFiltro = fechaDesde.toISOString().split('T')[0];
            const hastaFiltro = fechaHasta.toISOString().split('T')[0];
            const tiposArray = tipoProducto.join(',');
            
            const url = buildProductosUrl([empresaId], desdeFiltro, hastaFiltro, tiposArray);
            const data = await fetchData(url);
            handleProductosResponse(data);
        } catch (error) {
            console.error("Error al buscar productos:", error);
            setLoading(false);
        }
    };

    const limpiarFormulario = () => {
        setEmpresa(null);
        setEmpresaId(null);
        setTipoProducto([]);
        setFechaDesde(null);
        setFechaHasta(null);
        setProductosDisponibles([]);
        setCarro([]);
    };

    useEffect(() => {
        obtenerEmpresas();
    }, []);

    useEffect(() => {
        if (empresa) getTipoProductoByEmpresa(empresa);
    }, [empresa]);

    return (
    <div className="grid">
        <div className="col-12">
            <div className="card">
                <h4 style={{ marginBottom: "5px" }}>Productos Disponibles</h4>
                <h6 style={{ marginTop: "5px" }}>¿Qué productos están disponibles?</h6>
            </div>
            
        </div>
        <div className="col-12">
            <div className="card">
                <h6>
                    Seleccione empresa, tipo de producto y rango de fechas
                </h6>
                <div className="p-fluid formgrid grid" style={{ marginTop: "20px" }}>
                    <div className="field col-12 md:col-6">
                        <label>Empresa *</label>
                        <Dropdown
                            value={empresa}
                            options={[
                                { label: "TODAS", value: "TODAS" },
                                ...empresas.map(empresa => ({
                                    label: empresa.nombre,
                                    value: empresa.nombre
                                }))
                            ]}
                            onChange={(e) => {
                                setEmpresa(e.value);
                                if (e.value === "TODAS") {
                                    setEmpresaId("ALTAMIRA,LA SIEMBRA");
                                } else {
                                    const empresaSeleccionada = empresas.find(emp => emp.nombre === e.value);
                                    setEmpresaId(empresaSeleccionada?.id || null);
                                }
                                setTipoProducto([]);
                            }}
                            placeholder="Seleccione Empresa"
                        />
                    </div>

                    <div className="field col-12 md:col-6">
                        <label htmlFor="tipoproducto">Tipo Producto *</label>
                        <MultiSelect
                            value={tipoProducto}
                            onChange={(e) => setTipoProducto(e.value)}
                            options={tiposProducto.map((option) => ({
                                label: option.descripcion,
                                value: option.descripcion
                            }))}
                            optionLabel="label"
                            placeholder="Seleccione Tipo Producto"
                            filter
                        />
                    </div>

                    <div className="field col-12 md:col-6">
                        <label htmlFor="fechaDesde">Fecha Desde *</label>
                        <Calendar
                            value={fechaDesde}
                            onChange={handleFechaDesdeChange}
                            dateFormat="dd/mm/yy"
                            showIcon
                            showButtonBar
                            maxDate={fechaHasta || undefined}
                            placeholder="Seleccione una fecha"
                        />
                    </div>

                    <div className="field col-12 md:col-6">
                        <label htmlFor="fechaHasta">Fecha Hasta *</label>
                        <Calendar
                            value={fechaHasta}
                            onChange={handleFechaHastaChange}
                            dateFormat="dd/mm/yy"
                            showIcon
                            showButtonBar
                            minDate={fechaDesde || undefined}
                            placeholder="Seleccione una fecha"
                        />
                    </div>

                    <div className="field col-12 md:col-12 mt-2" style={{ display: "flex", justifyContent: "center", gap: "1rem"}}>
                        <Button
                            label="Limpiar"
                            icon="pi pi-trash"
                            className="mr-2 mb-2 p-button-rounded p-button-secondary p-button"
                            onClick={limpiarFormulario}
                            style={{ width: "400px" }}
                            raised
                        />
                        <Button
                            label="Buscar Productos"
                            icon="pi pi-search"
                            className="mr-2 mb-2 p-button-rounded p-button"
                            onClick={searchProductos}
                            style={{ width: "400px" }}
                            raised
                            disabled={loading}
                        />
                        
                    </div>
                    
                    <div className="col-12">
                        {productosDisponibles.length > 0 && (
                            <>
                                <div className="flex justify-content-between" style={{ marginTop: "5px" ,marginBottom: "5px"}}>
                                    <span className="p-input-icon-left" style={{ display: "flex", alignItems: "center", width: "300px" }}>
                                        <i className="pi pi-search" style={{ marginRight: "5px" }} />
                                        <InputText
                                            value={globalFilter}
                                            onChange={(e) => setGlobalFilter((e.target.value || '').toUpperCase())}
                                            placeholder="Buscar por Descripción"
                                        />
                                    </span>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "300px" }}>
                                        <span className="p-input-icon-left">
                                            Se encontraron {productosDisponibles.length} productos.
                                        </span>
                                    </div>
                                </div>
                            </>
                        )}
                        <>
                            {loading ? (
                                <Loader />
                            ) : (
                                <div className="col-12">
                                    <DataTable
                                        value={productosDisponibles}
                                        className="p-datatable-gridlines"
                                        showGridlines
                                        rows={10}
                                        rowsPerPageOptions={[10, 20, 50, 100]}
                                        dataKey="id"
                                        emptyMessage="No se encontraron productos."
                                        stripedRows
                                        selection={carro}
                                        onSelectionChange={(e) => setCarro(e.value)}
                                        paginator
                                        globalFilter={globalFilter}
                                        globalFilterFields={['nombre_producto', 'tipo_producto', 'empresa', 'metraje_producto', 'tarifa_base']}
                                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"   
                                        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} productos."
                                        scrollHeight="57vh"
                                        scrollable
                                    >
                                        <Column
                                            field="nombre_producto"
                                            header="Descripción"
                                            sortable
                                            body={(rowData) => (
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    
                                                    <span style={{ textTransform: "uppercase" }}>
                                                        {rowData.nombre_producto}
                                                    </span>

                                                </div>
                                            )}
                                        />
                                        <Column
                                            field="es_union"
                                            header="Estados"
                                            body={(rowData) => (
                                            <>
                                                <div>
                                                    {rowData.es_union ? (
                                                    <Button
                                                        icon="pi pi-link"
                                                        className="p-button-rounded p-button-secondary p-button mr-2 mb-2 mt-2"
                                                        outlined
                                                        tooltip="Producto Combinado"
                                                        tooltipOptions={{ position: 'top' }}
                                                    />
                                                    ) : (
                                                    <Button
                                                        icon="pi pi-check"
                                                        className="p-button-rounded p-button-success p-button mr-2 mb-2 mt-2"
                                                        outlined
                                                        tooltip="Producto Disponible"
                                                        tooltipOptions={{ position: 'top' }}
                                                    />
                                                    )}

                                                </div>
                                            </>
                                            )}
                                            sortable
                                        />
                                        <Column field="tipo_producto" header="Tipo" sortable />
                                        <Column field="empresa" header="Empresa" sortable />
                                        <Column
                                            field="metraje_producto"
                                            header="Metraje"
                                            body={(rowData) => (
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <span>{rowData.metraje_producto}</span>
                                                    <span style={{ marginLeft: "4px" }}>
                                                        {rowData.unidad === "m**2" ? "m²" : rowData.unidad}
                                                    </span>
                                                </div>
                                            )}
                                            sortable
                                        />
                                        <Column
                                            field="tarifa_base"
                                            header="Tarifa"
                                            body={(rowData) => (
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <span>{rowData.tarifa_base} {rowData.moneda}</span>
                                                </div>
                                            )}
                                            sortable
                                        />

                                        <Column
                                            header="Desde"
                                            body={() => fechaDesde?.toLocaleDateString("en-GB", { timeZone: "UTC" })}
                                        />
                                        <Column
                                            header="Hasta"
                                            body={() => fechaHasta?.toLocaleDateString("en-GB", { timeZone: "UTC" })}
                                        />
                                        <Column
                                            header="Servicios"
                                            body={(rowData) => (
                                                <span>
                                                    {rowData.oficina && <FontAwesomeIcon icon={faBuilding} style={{ color: "#0150a0" }} size="2xl" className="ml-2 mr-2 mb-1 mt-1" title="Oficina" />}
                                                    {rowData.bano && <FontAwesomeIcon icon={faRestroom} style={{ color: "#0150a0" }} size="2xl" className="ml-2 mr-2 mb-1 mt-1" title="Baño" />}
                                                    {rowData.modulo && <FontAwesomeIcon icon={faWarehouse} style={{ color: "#0150a0" }} size="2xl" className="ml-2 mr-2 mb-1 mt-1" title="Modulo" />}
                                                    {rowData.agua && <FontAwesomeIcon icon={faTint} style={{ color: "#0150a0" }} size="2xl" className="ml-2 mr-2 mb-1 mt-1" title="Agua" />}
                                                    {rowData.electricidad && <FontAwesomeIcon icon={faPlugCircleCheck} style={{ color: "#0150a0" }} size="2xl" className="ml-2 mr-2 mb-1 mt-1" title="Electricidad" />}
                                                    {rowData.internet && <FontAwesomeIcon icon={faWifi} style={{ color: "#0150a0" }} size="2xl" className="ml-2 mr-2 mb-1 mt-1" title="Internet" />}
                                                    {rowData.subproducto && <FontAwesomeIcon icon={faWarehouse} style={{ color: "#0150a0" }} size="2xl" className="ml-2 mr-2 mb-1 mt-1" title="Subproducto" />}
                                                </span>
                                            )}
                                        />
                                        <Column
                                            header="Ficha Técnica"
                                            body={(rowData) => (
                                                <span>
                                            
                                                    <Button
                                                        icon="pi pi-file-o"
                                                        className="p-button-rounded p-button-info p-button-outlined p-button mr-2 mb-2 mt-2"
                                                        tooltip="Ver Ficha Técnica"
                                                        label="Ficha"
                                                        onClick={() => openFichaModal(rowData)}
                                                    />
                                                </span>
                                            )}
                                        />
                                    </DataTable>
                                </div>
                            )}  
                        </>
                    </div>
                </div>
            </div>
        </div>
        <FichaTecnicaModal
            visible={showFichaModal}
            onHide={closeFichaModal}
            productoId={selectedProductoFicha?.id}
            productoDescripcion={selectedProductoFicha?.descripcion}
        />
    </div>
    );
};

export default ProductosDisponibles;
